var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12.8774C13.8277 12.8774 12.8774 13.8277 12.8774 15C12.8774 16.1723 13.8277 17.1226 15 17.1226C16.1723 17.1226 17.1226 16.1723 17.1226 15C17.1226 13.8277 16.1723 12.8774 15 12.8774ZM10.8962 15C10.8962 12.7335 12.7335 10.8962 15 10.8962C17.2665 10.8962 19.1038 12.7335 19.1038 15C19.1038 17.2665 17.2665 19.1038 15 19.1038C12.7335 19.1038 10.8962 17.2665 10.8962 15Z",
    fill: "#00A0CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.5C10.8579 7.5 7.5 10.8579 7.5 15C7.5 19.1421 10.8579 22.5 15 22.5C19.1421 22.5 22.5 19.1421 22.5 15C22.5 10.8579 19.1421 7.5 15 7.5ZM5.51887 15C5.51887 9.76372 9.76372 5.51887 15 5.51887C20.2363 5.51887 24.4811 9.76372 24.4811 15C24.4811 20.2363 20.2363 24.4811 15 24.4811C9.76372 24.4811 5.51887 20.2363 5.51887 15Z",
    fill: "#00A0CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.98113C7.80988 1.98113 1.98113 7.80988 1.98113 15C1.98113 22.1901 7.80988 28.0189 15 28.0189C22.1901 28.0189 28.0189 22.1901 28.0189 15C28.0189 7.80988 22.1901 1.98113 15 1.98113ZM0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "#00A0CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/Title.535f0fa5c32207dadb5cf570758aefdf.svg";
export { ForwardRef as ReactComponent };